<template>
    <span>{{ val }} </span>
</template>
  
<script>
export default {
    props: {
        row: {},
        cusprop: {
            type: String,
            default: "",
        },
    },
    computed: {
        val() {
            return this.$jsonPath(this.row, this.cusprop) == 0 ? "本机" : this.$jsonPath(this.row, this.cusprop);
        }
    }
}
</script>